module.exports = __webpack_public_path__ + "img/schmiedegitter.d5e92c8b.jpg";